import axios, { AxiosError, AxiosHeaders, InternalAxiosRequestConfig } from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_UNIFIED_COMMS_ENDPOINT,
});

const errorHandler = (error: AxiosError) => {
  const statusCode = error.response?.status;

  if (statusCode && statusCode !== 401) {
    console.error(error);
  }

  return Promise.reject(error);
};

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    config.headers = new AxiosHeaders(config.headers);
    config.headers.set("Content-Type", "application/json");
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(undefined, (error) => {
  return errorHandler(error);
});